import store from '@/store';
import { RouteNameEnum } from '@/router/RouteName';
import { isRouteNameInRoute, logGuard, } from '@/router/helpers';
import { User } from '@/models/User';
import { RolesEnum } from '@/items/Roles';
const userRole = (role, user) => {
    return (!!role &&
        !!user.roles &&
        user.roles.some((userRole) => userRole && userRole.id === role));
};
export const roleBasedRedirectMiddleware = async (to, _from) => {
    logGuard('[ROLE_BASED_REDIRECT_MIDDLEWARE]');
    const user = User.currentAuth();
    const version = store.state.version;
    if (user && version === '1') {
        logGuard('[ROLE_BASED_REDIRECT_MIDDLEWARE], has user and version', user, version);
        if (user.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.TEACHER,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ])) {
            logGuard('[ROLE_BASED_REDIRECT_MIDDLEWARE], is teacher or administrator');
            return isRouteNameInRoute(RouteNameEnum.CURRICULUM, to)
                ? true
                : { name: RouteNameEnum.CURRICULUM, params: { id: 'current' } };
        }
        if (user.hasRole([RolesEnum.STUDENT])) {
            logGuard('[ROLE_BASED_REDIRECT_MIDDLEWARE], is student');
            return isRouteNameInRoute(RouteNameEnum.STUDENT_FINISHED, to)
                ? true
                : { name: RouteNameEnum.STUDENT_FINISHED, params: { id: user.id || '' } };
        }
    }
    logGuard('[ROLE_BASED_REDIRECT_MIDDLEWARE], has no user or no version');
    return true;
};
